import React, { useMemo, useState } from "react";
import AdminPageShell from "./AdminPageShell";
import useFetch from "../../useFetch";
import Pagination from "../Pagination";

const formatDate = (date) => date ? new Date(date).toLocaleString() : "Not available";

const AdminAuditLogs = () => {
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [appliedKeyword, setAppliedKeyword] = useState("");

  const apiUrl = useMemo(() => {
    const params = new URLSearchParams();
    params.set("per_page", "15");
    params.set("page", page);
    if (appliedKeyword) params.set("keyword", appliedKeyword);

    return process.env.REACT_APP_BASE_API_URL + "/admin/audit-logs?" + params.toString();
  }, [appliedKeyword, page]);

  const { response, isLoading, error } = useFetch(apiUrl);
  const logs = response?.audit_logs?.data ?? [];
  const meta = response?.audit_logs?.meta ?? {};

  const submitFilters = (e) => {
    e.preventDefault();
    setPage(1);
    setAppliedKeyword(keyword.trim());
  };

  const clearFilters = () => {
    setKeyword("");
    setAppliedKeyword("");
    setPage(1);
  };

  return (
    <AdminPageShell
      active="audit"
      title="Audit Logs"
      text="Track important admin actions for accountability and troubleshooting."
    >
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Admin Activity History</h4>
        </div>

        <form className="admin-filter-bar" onSubmit={submitFilters}>
          <div className="admin-filter-field">
            <label>Search</label>
            <input type="text" value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder="Action, target, or admin" />
          </div>
          <div className="admin-filter-actions">
            <button type="submit" className="theme-btn btn-style-one">Search</button>
            <button type="button" className="theme-btn btn-style-three" onClick={clearFilters}>Clear</button>
          </div>
        </form>

        <div className="widget-content">
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}
          {!error && !isLoading && <div className="admin-list-summary">Showing {logs.length} of {meta.total ?? 0} audit logs</div>}

          <div className="admin-table-list">
            {!error && !isLoading && logs.map((log) => (
              <div className="admin-table-row admin-application-row" key={log.id}>
                <div>
                  <strong>{log.label}</strong>
                  <span>{log.target_label || "Platform"} - {formatDate(log.created_at)}</span>
                  <span>{log.admin_name || "Admin"}{log.ip_address ? ` - ${log.ip_address}` : ""}</span>
                </div>
                <div className="admin-row-actions">
                  <span>{log.target_type || "System"}</span>
                </div>
              </div>
            ))}
            {!error && !isLoading && logs.length === 0 && <div className="admin-empty-state">No audit logs found.</div>}
          </div>

          {!error && !isLoading && <Pagination meta={meta} onPageChange={setPage} label="Audit log pagination" />}
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminAuditLogs;
